import React from 'react';
import styled from 'styled-components';
import { PromoIdentifier, gridConfig } from '@tvg/fuse-design';

interface Props {
  text: string;
  colour: string;
  productIdentifierId: string;
}

const Container = styled.div`
  margin: 0 calc(var(--spacing-space16) * -1);

  @media (min-width: ${gridConfig.m.minWidth}) {
    margin: 0 0 var(--spacing-space8);
  }

  @media (min-width: ${gridConfig.l.minWidth}) {
    margin-bottom: var(--spacing-space16);
  }
`;

const StyledPromotionIdentifier = styled(PromoIdentifier)`
  > * {
    font-size: var(--font-size-m2);
    line-height: var(--font-line-height-m2);

    @media (min-width: ${gridConfig.l.minWidth}) {
      font-size: var(--font-size-1);
      line-height: var(--font-line-height-1);
    }
  }
`;

const ClickableWrapper = styled.a`
  cursor: pointer;
  text-decoration: none;
  color: inherit;
`;

function PromotionIdentifier({ text, colour, productIdentifierId }: Props) {
  const blackFridayLink = '/promo/black-friday-deals?numProducts=96';
  const content = <StyledPromotionIdentifier text={text} color={colour} />;
  const BLACK_FRIDAY_PROMO_IDS = new Set([
    'very-black-friday-deal-identifier',
    'very-black-friday-new-deal-identifier',
    'very-black-friday-midnight-deal-identifier',
  ]);
  const isBlackFridayPromotion = !!(productIdentifierId && BLACK_FRIDAY_PROMO_IDS.has(productIdentifierId));

  return (
    <Container>
      {isBlackFridayPromotion ? (
        <ClickableWrapper data-transaction-name="BlackFridayPromotion" href={blackFridayLink}>
          {content}
        </ClickableWrapper>
      ) : (
        content
      )}
    </Container>
  );
}

export default PromotionIdentifier;
